const resources = {
    seeMore: 'See more reviews that mention',
    linkLead: 'Highly rated by customers for:',
    modalTitle: 'Highly Rated by Customers for'
};

module.exports = function getResource(label) {
    return resources[label];
};
